import { isNullOrUndefined } from '../typeGuards';

export type Modifier<T extends string> = T | (T | null | undefined | false)[] | null;

/** Create an array of Strings from Modifier Type, since it can be string or string[] */
export function modifierToArray(modifier?: Modifier<string>) {
  if (isNullOrUndefined(modifier)) {
    return [];
  }
  return Array.isArray(modifier) ? modifier : [modifier];
}

export function appendModifiers<T extends string>(existing: Modifier<T> | undefined, additional?: Modifier<T>) {
  return [...modifierToArray(existing), ...modifierToArray(additional)] as T[];
}
